import { createAuthenticator } from 'redux-simple-auth'
import { revoke, isValid } from 'utils/token'

export default createAuthenticator({
  name: 'oauth2-implicit-grant',
  restore: data => (isValid(data) ? Promise.resolve(data) : Promise.reject()),
  authenticate: data =>
    new Promise((resolve, reject) => {
      if (!data || !data.access_token) {
        reject('Invalid auth params - "access_token" missing.')
      } else {
        resolve(data)
      }
    }),
  invalidate: ({ access_token }) => revoke(access_token)
})



// WEBPACK FOOTER //
// ./src/authenticators/oauth2ImplicitGrant.js